/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { useRouteMatch, Switch, useHistory, Route, Redirect, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Col, Row, Typography, Steps } from 'antd';
import { Persist } from 'formik-persist';
import store from 'store';
import {
  getInstructionRoutes,
  getMentalHealthScreening,
  getmentalHealthSymptomsRoutes
} from '../../../routes/mobile/speak-doctor/mentalHealthRoutes';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import MobileMentalQuestionsNavBtn from '../../../components/mobile/form-helpers/MentalQuestionsNavBtn';
import { errorNotification } from '../../../utils/notification-helpers';
import { postScreeningAPICall } from '../../../api/speak-doctor';
import AuthGuestLoggedin from '../../../services/AuthGuestLoggedinService';
import { MENTAL_HEALTH_QUESTION_HEALTH_CONCERN_APPOINTMENT } from '../../../config/constants';

const authCheck = new AuthGuestLoggedin()

const QuestionWrapper = ({
  title,
  SvgIcon,
  children,
  isLabelHidden,
  ...restNavBtnProps
}) => {
  const { t } = useTranslation(['mental-health']);
  const location = useLocation();
  const history = useHistory();
  const { Step } = Steps;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (restNavBtnProps.currentValues) {
      if (restNavBtnProps.section === "section_d" && Object.values(restNavBtnProps.currentValues.section_c).includes("")) {
        history.push(restNavBtnProps.prevRoutePath);
      } else if (restNavBtnProps.section === "section_c" && Object.values(restNavBtnProps.currentValues.section_b).includes("")) {
        history.push(restNavBtnProps.prevRoutePath);
      } else if (restNavBtnProps.section === "section_b" && Object.values(restNavBtnProps.currentValues.section_a).includes("")) {
        history.push(restNavBtnProps.prevRoutePath);
      }
    }
  }, [history, restNavBtnProps]);

  return (
    <>
      {SvgIcon && (
        <Row justify="center">
          <Col style={{}}>
            <SvgIcon />
          </Col>
        </Row>
      )}
      {
        !restNavBtnProps.isInstructionPage && (
          <>
            <Typography fontWeight={500} style={{color: "#15A9E1", textAlign: "center"}}>
              {title}
            </Typography>
            {
              !isLabelHidden
                ? <Box marginTop="30px" background="#f4fafd" paddingY="12px" paddingRight="5px" paddingLeft="10px">
                  <Typography>{t("mental-health:section-description")}</Typography>
                </Box>
                : ""
            }
            {
              restNavBtnProps.isSubmit
                ? (
                  <>
                    <Typography style={{ marginTop: 30, paddingY: 12 }}>{t("mental-health:section-d.section-description")}</Typography>
                    <Box marginTop="30px" background="#f4fafd" paddingY="12px" paddingRight="5px" paddingLeft="10px">
                      <Typography>{t("mental-health:section-d.section-instructions.description")}</Typography>
                      <Steps progressDot current={-1} style={{paddingLeft: "20px", marginTop: "10px"}} direction="vertical">
                        <Step style={{paddingY: "5px"}} description={t("mental-health:section-d.section-instructions.list.haveYourCurrent")} />
                        <Step style={{paddingY: "5px"}} description={t("mental-health:section-d.section-instructions.list.whatIsTheDuration")} />
                        <Step style={{paddingY: "5px"}} description={t("mental-health:section-d.section-instructions.list.toWhatExtent")} />
                        <Step style={{paddingY: "5px"}} description={t("mental-health:section-d.section-instructions.list.doYouHave")} />
                        <Step style={{paddingY: "5px"}} description={t("mental-health:section-d.section-instructions.list.isThereA")} />
                        <Step style={{paddingY: "5px"}} description={t("mental-health:section-d.section-instructions.list.anyAdditionalNotes")} />
                      </Steps>
                    </Box>
                  </>
                ) : ""
            }
          </>
        )
      }
      {children}
      <MobileMentalQuestionsNavBtn {...restNavBtnProps} />
    </>
  );
};

function MobileMentalHealthQuestionScreen() {
  const { t } = useTranslation(['mental-health']);
  const match = useRouteMatch();
  const history = useHistory();
  const { path } = match;

  const initialValues = {
    sectionA: {
      LittleInterestOrPleasureDoingThings: "",
      FeelingDownDepressedHopeless: "",
      TroubleFallingStayingAsleepSleepingTooMuch: "",
      FeelingTiredHavingLittleEnergy: "",
      PoorAppetiteOvereating: "",
      FeelingBadAboutYourself: "",
      TroubleConcentrating: "",
      MovingSpeaking: "",
      ThoughtsOfDead: "",
      IfYouCheckedOffAnyProblems: "",
    },
    sectionB: {
      FeelingNervousAnxious: "",
      NotBeingAbleToControlWorrying: "",
      WorryingTooMuchAboutDifferentThings: "",
      TroubleRelaxing: "",
      BeingRestless: "",
      BecomingEasilyAnnoyedIrritable: "",
      FeelingAfraid: "",
      IfYouCheckedOffAnyProblems: "",
    },
    sectionC: {
      FeelAfraidNothingCalmDown: "",
      FeelAngryOutOfControl: "",
      FeelUninterestedInThings: "",
      FeelHopeless: "",
      FeelSeverelyUpset: "",
      FeelUnableToCarryEssentialActivities: "",
    },
    sectionD: {
      mentalHealthDifficulties: ""
    }
  };

  const [currentValues, setCurrentValues] = useState(false);

  useEffect(() => {
    if (!currentValues) {
      const values = {};
      const storeValues = store.get("mental-health-form")?.values;
      if (storeValues) {
        Object.keys(initialValues).map(sectionKey => {
          Object.keys(initialValues[sectionKey]).map(key => {
            values[sectionKey] = {
              ...values[sectionKey],
              [key]: storeValues[key]
            }
            return key;
          })
          return sectionKey;
        })
        setCurrentValues(values);
      }
    }
  }, [currentValues, initialValues]);


  const validateScreeningData = (values) => {
    const isEmpty = Object.values(values).includes("");

    if (isEmpty) return false;

    return true;
  };

  const getDataForSubmission = (values) => {
      const dataForSubmission = {};
      const initials = initialValues;

      Object.keys(values).map(key => {
        if(Object.keys(initials.sectionA).includes(key)){
            dataForSubmission.sectionA = {
                ...dataForSubmission.sectionA,
                [key]: values[key]
            };
            dataForSubmission.sectionA.score = (dataForSubmission.sectionA?.score || 0) + values[key];

            if (dataForSubmission.sectionA.score >= 0 && dataForSubmission.sectionA.score <= 4) {
              dataForSubmission.sectionA.result = "None-minimal"
            }
            else if (dataForSubmission.sectionA.score >= 5 && dataForSubmission.sectionA.score <= 9) {
              dataForSubmission.sectionA.result = "Mild Depression"
            }
            else if (dataForSubmission.sectionA.score >= 10 && dataForSubmission.sectionA.score <= 14) {
              dataForSubmission.sectionA.result = "Moderate Moderate Depression"
            }
            else if (dataForSubmission.sectionA.score >= 15 && dataForSubmission.sectionA.score <= 19) {
              dataForSubmission.sectionA.result = "Moderately Severe Depression"
            }
            else if (dataForSubmission.sectionA.score >= 20 && dataForSubmission.sectionA.score <= 27) {
              dataForSubmission.sectionA.result = "Severe Depression"
            }
        }
        else if(Object.keys(initials.sectionB).includes(key)){
            dataForSubmission.sectionB = {
                ...dataForSubmission.sectionB,
                [key]: values[key]
            };
            dataForSubmission.sectionB.score = (dataForSubmission.sectionB?.score || 0) + values[key];

            if (dataForSubmission.sectionB.score >= 0 && dataForSubmission.sectionB.score <= 5) {
              dataForSubmission.sectionB.result = "Mild Anxiety"
            }
            else if (dataForSubmission.sectionB.score >= 6 && dataForSubmission.sectionB.score <= 10) {
              dataForSubmission.sectionB.result = "Moderate Anxiety"
            }
            else if (dataForSubmission.sectionB.score >= 11 && dataForSubmission.sectionB.score <= 15) {
              dataForSubmission.sectionB.result = "Moderately Severe Anxiety"
            }
            else if (dataForSubmission.sectionB.score >= 15 && dataForSubmission.sectionB.score <= 21) {
              dataForSubmission.sectionB.result = "Severe Anxiety"
            }
        }
        else if(Object.keys(initials.sectionC).includes(key)){
            dataForSubmission.sectionC = {
                ...dataForSubmission.sectionC,
                [key]: values[key],
                result: ""
            };
            dataForSubmission.sectionC.score = (dataForSubmission.sectionC?.score || 0) + values[key];
        }
        else if(Object.keys(initials.sectionD).includes(key)){
            dataForSubmission.sectionD = {
                ...dataForSubmission.sectionD,
                [key]: values[key]
            };
        }

        return key;
      });

      return dataForSubmission;
  };

  const handleChange = (name, val) => {
    const tempCurrentValues = currentValues;
    Object.keys(tempCurrentValues).map(key => {
      if ({...tempCurrentValues[key]}?.hasOwnProperty(name)) {
        tempCurrentValues[key][name] = val;
      }
      return val;
    });

    setCurrentValues(tempCurrentValues);
  }

  const renderRoutes = (routes, total = routes.length) =>
    routes.map(({ id: count, path: p, component: Component, props: componentProps }) => {
      const {
        title,
        isLabelHidden,
        section,
        navBttonText,
        isInstructionPage,
        prevRoutePath,
        nextRoutePath,
        isLastQuestion,
        SvgIcon,
        isSubmit,
        isSurveyCompleted,
        additionalRoute,
        recommendedRoute,
        isMultiSelect,
        ...restComponentProps
      } = componentProps;

      return (
        <Route key={p} path={p}>
          <QuestionWrapper
            title={
              title
                ? t("mental-health:section", { label: t(section?.label), title: t(title) })
                : t("mental-health:section-count", { label: t(section?.label), count, total: total + 1 })
            }
            isLabelHidden={isLabelHidden}
            SvgIcon={SvgIcon}
            isLastQuestion={isLastQuestion}
            isSubmit={isSubmit}
            currentValues={currentValues}
            section={section?.value}
            navBttonText={navBttonText}
            isSurveyCompleted={isSurveyCompleted}
            isInstructionPage={isInstructionPage}
            prevRoutePath={prevRoutePath}
            nextRoutePath={nextRoutePath}
            additionalRoute={additionalRoute}
            recommendedRoute={recommendedRoute}
            fieldName={componentProps.fieldName}
          >
            <Component
              fieldName={componentProps.fieldName}
              isMultiSelect={isMultiSelect}
              handleChange={handleChange}
              {...restComponentProps}
            />
          </QuestionWrapper>
        </Route>
      );
    });

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
            ...initialValues.sectionA,
            ...initialValues.sectionB,
            ...initialValues.sectionC,
            ...initialValues.sectionD
        }}
        onSubmit={async (values, { setSubmitting, resetForm }) => {

          const answers = { ...values };

          const isValid = validateScreeningData(answers);

          if (!isValid) {
            errorNotification(t('common:form.error.allFieldsAreRequired'));
            setSubmitting(false);
          } else {
            const dataForSubmission = getDataForSubmission(answers);
            console.log("dataForSubmission", dataForSubmission)
            // try {
            //   const { responseOk, responseJSON } = await postScreeningAPICall({
            //     mentalHealthQuestionnaires: dataForSubmission
            //   });
            //   store.set(MENTAL_HEALTH_QUESTION_HEALTH_CONCERN_APPOINTMENT, dataForSubmission.sectionD.mentalHealthDifficulties)
            //   setSubmitting(false);
            //   resetForm({ values: {
            //     ...initialValues.sectionA,
            //     ...initialValues.sectionB,
            //     ...initialValues.sectionC,
            //     ...initialValues.sectionD
            //   }});
            //   if (!responseOk) {
            //     throw new Error(`${responseOk} - ${responseJSON}`);
            //   }
            //   authCheck.redirectSpeakDoctor()
            // } catch (err) {
            //   console.error(err);
            //   errorNotification(t('common:form.error.submit'));
            //   setSubmitting(false);
            //   resetForm({ values: {
            //     ...initialValues.sectionA,
            //     ...initialValues.sectionB,
            //     ...initialValues.sectionC,
            //     ...initialValues.sectionD
            //   }})
            //   history.push(`/speak-doctor/mental-health-questions/infomation`);
            // }
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form loading={isSubmitting.toString()}>
            {isSubmitting}
            <Box paddingTop={20} paddingBottom={36} paddingX={20}>
              <Switch>
                {
                  renderRoutes(
                    getInstructionRoutes()
                  )
                }
                {
                  renderRoutes(
                    getMentalHealthScreening(),
                    getMentalHealthScreening().length - 1
                  )
                }
                {
                  renderRoutes(
                    getmentalHealthSymptomsRoutes(),
                  )
                }
                {/* <Redirect to={`${path}/emergency-symptoms`} /> */}
                <Redirect to={`${path}/infomation`} />
              </Switch>
            </Box>
            {!isSubmitting && <Persist name="mental-health-form" />}
            {isSubmitting ? (
              <LoadingSpinner position="full" transparent={false} />
            ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
}

export default MobileMentalHealthQuestionScreen;
